import React, { useEffect, useState } from "react";
import performRequest from "../../../api/request";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { Toast } from "../../../CustomComponent/toast";
import { useSelector } from "react-redux";
import LoadingPage from "../../../Components/layouts/loading";
import CustomViewButton from "../../../CustomComponent/custom_view_button";
import { useNavigate } from "react-router-dom";

const Schedule_table = ({ data, currentPage, itemsPerPage }) => {
  const store = useSelector((store) => store.login.user);
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = React.useState(data);
  const [archivingId, setArchivingId] = useState(null);
  const [updatingId, setUpdatingId] = useState(null);

  const navigate = useNavigate();

  const tableHead = [
    "Sr.",
    "Schedule Name / Schedule Id",
    "Page Name",
    "Format / Platforms",
    "Start / End Date",
    "Time / Count",
    "Inactive / Active",
    "Actions",
    "Archived",
  ];

  useEffect(() => {
    setTableData(data);
  }, [data]);

  const goToView = (id) => {
    navigate(`/view-schedules/${id}`);
  };

  const handleToggleStatus = async (item) => {
    try {
      setUpdatingId(item.scheduleGroupId);

      const newStatus = !item.isActive;

      await performRequest(
        "PATCH",
        `/postPlanning/update-active-status/${item.scheduleGroupId}`,
        {
          isActive: newStatus,
        }
      );

      // update UI
      setTableData((prev) =>
        prev.map((data) =>
          data.scheduleGroupId === item.scheduleGroupId
            ? {
                ...data,
                isActive: newStatus,
              }
            : data
        )
      );
    } catch (error) {
      CustomErrorResponse(error);
    } finally {
      setUpdatingId(null);
    }
  };

  const handleArchive = async (item) => {
    try {
      setArchivingId(item.scheduleGroupId);

      await performRequest(
        "PATCH",
        `/postPlanning/update-archived/${item.scheduleGroupId}`,
        {
          isArchived: true,
        }
      );

      // Hide from current table only.
      // Data is not deleted from the database.
      setTableData((prev) =>
        prev.filter((data) => data.scheduleGroupId !== item.scheduleGroupId)
      );

      Toast("success", "Schedule archived successfully");
    } catch (error) {
      CustomErrorResponse(error);
    } finally {
      setArchivingId(null);
    }
  };

  return (
    <>
      {loading && <LoadingPage />}
      <div className="table-responsive">
        <table className="table table-vcenter">
          <thead>
            <tr>
              {tableHead?.map((item, index) => {
                return (
                  <>
                    <th key={index}>{item}</th>
                  </>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {tableData?.map((item, index) => {
              const Index = (currentPage - 1) * itemsPerPage + index + 1;
              return (
                <tr
                  key={item?.id}
                  className={
                    item?.uploadedMediaCount >= 15 ? "bg-green-lt" : "bg-red-lt"
                  }
                >
                  <td>{Index}</td>

                  <td>
                    {item?.scheduleName
                      ? item.scheduleName
                          .split(" ")
                          .map(
                            (word) =>
                              word.charAt(0).toUpperCase() + word.slice(1)
                          )
                          .join(" ")
                      : "N/A"}
                    <div className="border"></div>
                    {item?.scheduleGroupId || "N/A"}
                  </td>
                  <td>
                    {item?.pageName}
                    <div className="border"></div>
                    {item?.days || "N/A"}
                  </td>

                  <td>
                    {`${item?.format} ( ${item?.contentType} )`}
                    <div className="border"></div>
                    {item?.platforms
                      ?.map(
                        (platform) =>
                          platform.charAt(0).toUpperCase() + platform.slice(1)
                      )
                      .join(", ")}
                  </td>
                  <td>
                    {item?.startDate}
                    <div className="border"></div>
                    {item?.endDate}
                  </td>

                  <td>
                    {new Date(`1970-01-01T${item.time}`).toLocaleTimeString(
                      "en-US",
                      {
                        hour: "numeric",
                        minute: "2-digit",
                        hour12: true,
                      }
                    )}
                    <div className="border"></div>
                    {item?.uploadedMediaCount} / {item?.totalSchedules}
                  </td>

                  <td>
                    <label className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={item?.isActive}
                        disabled={updatingId === item.scheduleGroupId}
                        onChange={() => handleToggleStatus(item)}
                        style={{ height: "25px", width: "50px" }}
                      />

                      {/* <span className="ms-2">
                        {item?.isActive ? "Active" : "Inactive"}
                      </span> */}
                    </label>
                  </td>

                  <td>
                    <CustomViewButton
                      onClick={() => goToView(item?.scheduleGroupId)}
                    ></CustomViewButton>
                  </td>
                  <td>
                    <button
                      type="button"
                      className="btn btn-red btn-sm"
                      disabled={archivingId === item.scheduleGroupId}
                      onClick={() => handleArchive(item)}
                    >
                      {archivingId === item.scheduleGroupId
                        ? "Archiving..."
                        : "Archive"}
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {/* <div
        className="modal modal-blur fade"
        id={`modal-view`}
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered w-100">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                {modalData?.page} - {modalData?.format}
              </h5>
              <span
                data-bs-toggle="modal"
                data-bs-target="#modal-course"
                id={`open-model`}
              ></span>
              <button
                id={`modal-close`}
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div>
                <div className="row mb-3">
                  <label className="form-label  col-3">Date & Time</label>
                  <div className="col-9">
                    {modalData?.date || "N/A"} - {modalData?.day} -{" "}
                    {modalData?.time || "N/A"}
                  </div>
                </div>

                <div className="row mb-3">
                  <label className="form-label  col-3">Published</label>
                  <div className="col-9">
                    {modalData?.published ? (
                      <FaCheckCircle fontSize={"20px"} color="#34A853" />
                    ) : (
                      <FaCircleXmark fontSize={"20px"} color="#D80001" />
                    )}
                  </div>
                </div>
                <div className="row mb-3">
                  <label className="form-label  col-3">Topic</label>
                  <div className="col-9">{modalData?.topic || "N/A"}</div>
                </div>
                <div className="row mb-3">
                  <label className="form-label col-3">Description</label>
                  <div className="col-9">{modalData?.description || "N/A"}</div>
                </div>

                <div className="row mb-3">
                  <label className="form-label  col-3">
                    Media (upload to cloudinary)
                  </label>
                  <div className="col-9">
                    {modalData?.filepath ? (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                        }}
                      >
                        <span
                          style={{
                            maxWidth: "180px",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                          }}
                          title={modalData?.filepath}
                        >
                          {modalData?.filepath || "N/A"}
                        </span>

                        {modalData?.filepath && (
                          <button
                            onClick={() => handleCopy(modalData?.filepath)}
                            style={{
                              border: "none",
                              background: "transparent",
                              cursor: "pointer",
                              fontSize: "18px",
                              fontWeight: "500",
                            }}
                          >
                            ⧉
                          </button>
                        )}
                      </div>
                    ) : (
                      "N/A"
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      </div>
    </>
  );
};

export default Schedule_table;
